module.exports = __webpack_public_path__ + "img/v37.b79fe836.jpg";